module.exports = __webpack_public_path__ + "img/group-5.5a34c877.svg";